<template>
  <v-container fluid fill-height>
    <v-layout row>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-tabs v-model="activeTab" grow slider-color="primary">
              <v-tab href="#data" active-class="tabs__item--active dps-tab-selected">
                {{ $t('private_info_title_info') }}
              </v-tab>

              <v-tab href="#managers" active-class="tabs__item--active dps-tab-selected">
                {{ $t('private_info_title_managers') }}
              </v-tab>

              <v-tab href="#contacts" active-class="tabs__item--active dps-tab-selected">
                {{ $t('private_info_title_contacts') }}
              </v-tab>

              <v-tab href="#subscriptions" active-class="tabs__item--active dps-tab-selected">
                {{ $t('private_info_title_subscription') }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab">
              <v-tab-item value="data">
                <v-layout row wrap>
                  <v-flex xs12 text-xs-right>
                    <v-menu bottom left>
                      <v-btn slot="activator" color="primary" small round>
                        <label class="caption capitalize white--text font-weight-bold">{{ $t(`global_lang_${this.currentLanguage}`) }}</label>
                      </v-btn>
                      <v-list>
                        <v-list-tile v-for="item in languages" :key="item.code" :value="item.code" @click="updateLanguage(item)">
                          <v-list-tile-title>{{ $t(`global_lang_${item}`) }}</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-5">
                  <v-flex xs12 md4>
                    <v-card height="100%">
                      <v-responsive>
                        <img id="parkingImage" :src="parking.image" @error="$event.target.src = 'https://via.placeholder.com/320x225'" />
                      </v-responsive>
                      <v-card-actions>
                        <a :href="parkingMap" target="_blank" style="font-size:13px">{{ parking.address }}</a>
                      </v-card-actions>
                      <v-card-actions>
                        <a :href="parking.url" target="_blank" style="font-size:13px">Link</a>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 md8 :class="{ 'pl-3': $vuetify.breakpoint.smAndUp }">
                    <v-card>
                      <v-card-title class="pa-0">
                        <v-subheader>
                          {{ $t('private_parking_file_data_description') }}
                        </v-subheader>

                        <v-chip disabled id="price" color="accent" class="font-weight-bold" outline> {{ parking.price }} </v-chip>
                      </v-card-title>
                      <v-card-text class="pt-0"><span v-html="parkingDescription"/></v-card-text>
                    </v-card>
                    <v-card class="mt-2">
                      <template v-for="access in parkingAccess">
                        <v-card-title class="pa-0" :key="access.title + 'W'">
                          <v-subheader>{{ access.title }} </v-subheader>
                        </v-card-title>
                        <v-card-text class="pt-0" :key="access.title + 'C'"><span v-html="access.description"/></v-card-text>
                      </template>
                    </v-card>
                    <v-card class="mt-2" v-if="parkingObservations !== ''">
                      <v-card-title class="pa-0">
                        <v-subheader>{{ $t('private_parking_file_data_observation') }} </v-subheader>
                      </v-card-title>
                      <v-card-text class="pt-0"><span v-html="parkingObservations"/></v-card-text>
                    </v-card>
                    <v-card class="mt-2" v-if="parkingObservationsBasedOnType !== ''">
                      <v-card-title class="pa-0">
                        <v-subheader>{{ $t('parking.description.typeText') }}</v-subheader>
                      </v-card-title>
                      <v-card-text class="pt-0"><span v-html="parkingObservationsBasedOnType"/></v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>

                <v-layout row wrap class="mt-5">
                  <div v-for="feature in parking.features" :key="feature.id">
                    <v-chip outline disabled style="padding:5px; float:left" color="primary" class="mt-1">
                      <img :src="`https://d3sff7pcqwremq.cloudfront.net/${feature.image}`" height="25" class="mr-2" />
                      {{ $t(`private_parking_file_data_features_${feature.name.toLowerCase()}`) }}
                    </v-chip>
                  </div>
                </v-layout>
              </v-tab-item>

              <v-tab-item value="managers">
                <v-data-table :headers="headers" :items="managers" hide-actions class="mt-4">
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.email }}</td>
                  </template>
                  <template slot="no-data">
                    <v-alert :value="true" outline color="info"><span v-html="$t('private_dash_table_earnings_nodata')"/></v-alert>
                  </template>
                </v-data-table>
              </v-tab-item>

              <v-tab-item value="contacts">
                <v-data-table :headers="headersContacts" :items="parking.contacts" hide-actions class="mt-4">
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.position }}</td>
                    <td>{{ props.item.email }}</td>
                    <td>{{ props.item.phone }}</td>
                    <td>{{ props.item.notes }}</td>
                  </template>
                  <template slot="no-data">
                    <v-alert :value="true" outline color="info"><span v-html="$t('private_dash_table_earnings_nodata')"/></v-alert>
                  </template>
                </v-data-table>
              </v-tab-item>

              <v-tab-item value="subscriptions">
                <v-layout row>
                  <v-flex xs12>
                    <v-card flat>
                      <v-card-title>
                        <v-container fluid class="panel">
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-text-field
                                append-icon="search"
                                label=""
                                single-line
                                hide-details
                                :placeholder="$t('private_global.filter')"
                                v-model="searchSubscription"
                              ></v-text-field>
                              <v-data-table
                                :headers="headersSubscription"
                                :items="subscriptions"
                                :rows-per-page-text="$t('global_tables_rows_page')"
                                :search="searchSubscription"
                                hide-actions
                                :custom-sort="customTableSort"
                              >
                                <template slot="items" slot-scope="props">
                                  <td>{{ props.item.name }}</td>
                                  <td class="text-xs-left"><span v-html="props.item.description" /></td>
                                  <td class="text-xs-right">{{ props.item.price }}</td>
                                </template>
                                <template slot="no-data">
                                  <v-alert :value="true" outline color="info"><span v-html="$t('private_dash_table_earnings_nodata')"/></v-alert>
                                </template>
                              </v-data-table>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-title>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import parkingService from '@/services/parkingService';
import managerService from '@/services/managerService';
import planService from '@/services/planService';
import store from '@/store';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';
import _ from 'lodash';

export default {
  name: 'ParkingInformation',
  data() {
    return {
      currentLanguage: store.state.langSelected.langIso,
      languages: [],
      parkingId: this.$route.params.id,
      parking: {
        name: '',
        address: '-',
        type: '-',
        image: 'https://via.placeholder.com/320x225',
        price: '-',
        lat: '',
        lon: '',
        links: [],
        url: '',
        features: [],
        description: {},
        billing: { name: '-', address: '-', cif: '-', accountNumber: '-', email: '-', phone: '-' },
        contacts: [{ name: '-', email: '-', phone: '-', position: '-', notes: '-' }],
        supportedLanguages: []
      },

      subscriptions: [
        {
          name: '',
          description: '-',
          price: '-'
        }
      ],
      parkingDescription: '',
      parkingObservations: '',
      parkingObservationsBasedOnType: '',
      parkingMap: '',
      activeTab: 'data',
      parkingAccess: [],
      managers: [{ email: '-' }],
      searchSubscription: [],
      headers: [
        {
          i18nText: 'private_parking_file_data_managers_email',
          text: this.$i18n.t('private_parking_file_data_managers_email'),
          align: 'left',
          value: 'email'
        }
      ],
      headersSubscription: [
        {
          i18nText: 'private_parking_subscriptions_table_name_label',
          text: this.$i18n.t('private_parking_subscriptions_table_name_label'),
          align: 'left',
          value: 'name'
        },
        {
          i18nText: 'private_parking_subscriptions_table_description_label',
          text: this.$i18n.t('private_parking_subscriptions_table_description_label'),
          align: 'left',
          value: 'description'
        },
        {
          i18nText: 'private_parking_subscriptions_table_price_label',
          text: this.$i18n.t('private_parking_subscriptions_table_price_label'),
          align: 'right',
          value: 'price'
        }
      ],
      headersContacts: [
        {
          i18nText: 'private_parking_file_data_contacts_name',
          text: this.$i18n.t('private_parking_file_data_contacts_name'),
          align: 'left',
          value: 'name'
        },
        {
          i18nText: 'private_parking_file_data_contacts_position',
          text: this.$i18n.t('private_parking_file_data_contacts_position'),
          align: 'left',
          value: 'position'
        },
        {
          i18nText: 'private_parking_file_data_contacts_email',
          text: this.$i18n.t('private_parking_file_data_contacts_email'),
          align: 'left',
          value: 'email'
        },
        {
          i18nText: 'private_parking_file_data_contacts_phone',
          text: this.$i18n.t('private_parking_file_data_contacts_phone'),
          align: 'left',
          value: 'phone'
        },
        {
          i18nText: 'private_parking_file_data_contacts_notes',
          text: this.$i18n.t('private_parking_file_data_contacts_notes'),
          align: 'left',
          value: 'notes'
        }
      ],
      headersContactsSm: [
        {
          i18nText: 'private_parking_file_data_contacts_name',
          text: this.$i18n.t('private_parking_file_data_contacts_name'),
          align: 'left',
          value: 'name'
        },
        {
          i18nText: 'private_parking_file_data_contacts_position',
          text: this.$i18n.t('private_parking_file_data_contacts_position'),
          align: 'left',
          value: 'position'
        }
      ]
    };
  },
  created() {
    if (store.state.parkingSelected !== null && this.parkingId === store.state.parkingSelected) {
      this.parking = store.state.parkingSelected;
    }
    EventBus.$on(keys.eventOnLanguageChanged, this.updateParkingDescription);
    EventBus.$on(keys.eventOnLanguageChanged, this.updateParkingDescription);
    this.loadParking();

    _.each(store.state.countryConstantsSelected.langs, obj => {
      this.languages.push(obj);
    });
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.updateParkingDescription);
    EventBus.$off(keys.eventOnLanguageChanged, this.updateTableLables);
  },
  methods: {
    loadParking() {
      var params = {
        parking: this.parkingId
      };
      parkingService.summary(params, this.summarySuccessHandler, this.summaryErrorHandler);
      managerService.list(params, this.managerListSuccessHandler, this.managerListErrorHandler);
      planService.listByParking(params, this.planListSuccessHandler, this.planListErrorHandler);
    },
    updateTableLables() {
      _.each(this.headersSubscription, it => {
        it.text = this.$i18n.t(it.i18nText);
      });
    },
    summarySuccessHandler(data) {
      this.parking = data;
      if (typeof this.parking.contacts === 'undefined') {
        this.parking.contacts = [];
      }
      this.updateParkingDescription();
      this.parkingMap = `https://maps.google.com/maps?z=12&t=m&q=loc:${data.lat}+${data.lon}`;

      store.commit('UPDATE_PARKING_SELECTED', this.parking);
    },
    summaryErrorHandler(error) {
      if (error.status === 404) {
        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: 'error_404',
          type: 'error'
        });
      }

      this.$router.push({ name: 'Dashboard' });
    },
    managerListSuccessHandler(data) {
      this.managers = _.map(data, itData => {
        return { email: itData };
      });
    },
    managerListErrorHandler() {},
    planListSuccessHandler(data) {
      this.subscriptions = [];
      _.each(data.data, itSubscription => {
        let subClone = _.cloneDeep(itSubscription);
        this.subscriptions.push(subClone);
      });
      console.dir(this.subscriptions);
    },
    planListErrorHandler() {},
    updateLanguage(val) {
      this.currentLanguage = val;
      this.updateParkingDescription();
    },
    updateParkingDescription() {
      _.each(this.headers, itHeader => {
        itHeader.text = this.$i18n.t(itHeader.i18nText);
      });

      _.each(this.headersContacts, itHeader => {
        itHeader.text = this.$i18n.t(itHeader.i18nText);
      });

      this.parkingAccess = [];
      this.parkingDescription = '';
      this.parkingObservations = '';
      this.parkingObservationsBasedOnType = '';

      let currentLanguage = this.currentLanguage.replace('-', '_');

      if (typeof this.parking.description[currentLanguage] !== 'undefined') {
        this.parkingDescription = this.parking.description[currentLanguage].description;

        if (typeof this.parking.description[currentLanguage].observation !== 'undefined') {
          this.parkingObservations = this.parking.description[currentLanguage].observation.text;
        }

        if (typeof this.parking.description[currentLanguage].type !== 'undefined') {
          this.parkingObservationsBasedOnType = this.parking.description[currentLanguage].type.text;
        }

        if (this.parking.description[currentLanguage].access[0] !== 'undefined') {
          _.each(this.parking.description[currentLanguage].access, access => {
            this.parkingAccess.push({
              title: this.$i18n.t(`private_parking_file_data_${access.icon.split('.')[0].replace('-', '_')}`),
              description: access.text
            });
          });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#price {
  position: absolute;
  right: 0;
  top: 5px;
  height: 23px;
}
</style>



// WEBPACK FOOTER //
// src/components/parking/Information.vue